import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";

import { Dropdown, FormField } from "@/ds";
import {
  EQUIPAMENTO_LABEL,
  FABRICANTE_LABEL,
  GRUPO_LABEL,
  MODELO_LABEL,
  NOME_COMPOSTO_LABEL,
  REVISAO_LABEL,
  SELECIONE_PLACEHOLDER,
  TIPO_MANUTENCAO_LABEL,
} from "../adicionar-escopo-macro-dialog.constants";
import modal from "../../planejamento-controle.modal.module.scss";
import styles from "./identificacao-equipamento.module.scss";
import type { IdentificacaoEquipamentoProps } from "./types-identificacao-equipamento";

const ROTULO = { label: modal.rotuloCampo };

export function IdentificacaoEquipamentoView({
  grupo,
  equipamento,
  tipoManutencao,
  fabricante,
  modelo,
  revisao,
  nome,
  aviso,
}: IdentificacaoEquipamentoProps) {
  return (
    <div className={styles.corpo} data-testid="adicionar-escopo-equipamento">
      {aviso ? (
        <Message
          className="p-message-block"
          severity={aviso.tom === "erro" ? "error" : "info"}
          text={aviso.texto}
          data-testid="adicionar-escopo-equipamento-aviso"
        />
      ) : null}
      <div className={styles.linha}>
        <FormField.Root
          required
          classNames={ROTULO}
          error={grupo.erro}
          disabled={grupo.desabilitado}
        >
          <FormField.Label>{GRUPO_LABEL}</FormField.Label>
          <FormField.Control>
            <Dropdown
              value={grupo.value}
              options={grupo.opcoes}
              placeholder={SELECIONE_PLACEHOLDER}
              onChange={(event) => grupo.onChange(event.value)}
              data-testid="adicionar-escopo-grupo"
            />
          </FormField.Control>
          <FormField.Error data-testid="adicionar-escopo-grupo-error" />
        </FormField.Root>
        <FormField.Root
          required
          classNames={ROTULO}
          error={equipamento.erro}
          disabled={equipamento.desabilitado}
        >
          <FormField.Label>{EQUIPAMENTO_LABEL}</FormField.Label>
          <FormField.Control>
            <Dropdown
              value={equipamento.value}
              options={equipamento.opcoes}
              placeholder={SELECIONE_PLACEHOLDER}
              onChange={(event) => equipamento.onChange(event.value)}
              data-testid="adicionar-escopo-equipamento-campo"
            />
          </FormField.Control>
          <FormField.Error data-testid="adicionar-escopo-equipamento-error" />
        </FormField.Root>
      </div>
      <div className={styles.linha}>
        <FormField.Root classNames={ROTULO}>
          <FormField.Label>{FABRICANTE_LABEL}</FormField.Label>
          <FormField.Control>
            <InputText readOnly value={fabricante} data-testid="adicionar-escopo-fabricante" />
          </FormField.Control>
        </FormField.Root>
        <FormField.Root classNames={ROTULO}>
          <FormField.Label>{MODELO_LABEL}</FormField.Label>
          <FormField.Control>
            <InputText readOnly value={modelo} data-testid="adicionar-escopo-modelo" />
          </FormField.Control>
        </FormField.Root>
      </div>
      <div className={styles.linha}>
        <FormField.Root
          required
          classNames={ROTULO}
          error={tipoManutencao.erro}
          disabled={tipoManutencao.desabilitado}
        >
          <FormField.Label>{TIPO_MANUTENCAO_LABEL}</FormField.Label>
          <FormField.Control>
            <Dropdown
              value={tipoManutencao.value}
              options={tipoManutencao.opcoes}
              placeholder={SELECIONE_PLACEHOLDER}
              onChange={(event) => tipoManutencao.onChange(event.value)}
              data-testid="adicionar-escopo-tipo-manutencao"
            />
          </FormField.Control>
          <FormField.Error data-testid="adicionar-escopo-tipo-manutencao-error" />
        </FormField.Root>
        {revisao !== null ? (
          <FormField.Root classNames={ROTULO}>
            <FormField.Label>{REVISAO_LABEL}</FormField.Label>
            <FormField.Control>
              <InputText readOnly value={revisao} data-testid="adicionar-escopo-revisao" />
            </FormField.Control>
          </FormField.Root>
        ) : null}
      </div>
      {nome !== null ? (
        <FormField.Root classNames={ROTULO}>
          <FormField.Label>{NOME_COMPOSTO_LABEL}</FormField.Label>
          <FormField.Control>
            <InputText readOnly value={nome} data-testid="adicionar-escopo-nome-composto" />
          </FormField.Control>
        </FormField.Root>
      ) : null}
    </div>
  );
}
